//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//

import React from "react";
import Button from "@material-ui/core/Button";
import PeopleIcon from "@material-ui/icons/People";
var ManageUsersButton = function ManageUsersButton(_ref) {
  var handleClick = _ref.handleClick;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    startIcon: /*#__PURE__*/React.createElement(PeopleIcon, null),
    style: {
      padding: "4px 10px"
    }
  }, "Manage Users"));
};
export default ManageUsersButton;